export default __webpack_public_path__ + "static/img7@2x-0b51c17c5d193fd95aef290c3abcce73.jpg";